module.exports = __webpack_public_path__ + "img/zp2.b29874af.png";